import {
    Box,
    Button,
    Grid,
    IconButton,
    TextField,
    Tooltip,
} from '@mui/material'
import TableComponents from '../../components/TableComponents'
import RemoveRedEyeOutlinedIcon from '@mui/icons-material/RemoveRedEyeOutlined'
import ContentCopyOutlinedIcon from '@mui/icons-material/ContentCopyOutlined'
import SaveOutlinedIcon from '@mui/icons-material/SaveOutlined'

// import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined'
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined'
import { useCallback, useEffect, useState } from 'react'
import axiosInstance from '../../config/axiosConfig'
import { urlConfig } from '../../config/apiConfig'
import { AlertPopup, handdleOpenAlert } from '../../components/StyleComponent'
import SendOutlinedIcon from '@mui/icons-material/SendOutlined'
import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined'
import LineForm from './Form/LineForm'

export default function LineOA({ update,  }) {
    const [accessToken, setAccessToken] = useState({ channel_access_token: '' })
    const [form, setForm] = useState({
        group_line_id: '',
    })
    const [row, setRow] = useState('')
    const [data, setData] = useState('')
    const [message, setMessage] = useState('')
    const [openAlert, setOpenAlert] = useState(false)
    const [loading, setLoading] = useState(false)
    const [open, setOpen] = useState(false)
    const [error, setError] = useState(false)
    const [showToken, setShowToken] = useState(false)

    const listMenu = [
        update && {
            title: 'Setting',
            icon: <SettingsOutlinedIcon color='secondary' />,
            action: () => setOpen(true),
        },
        {
            title: 'Test Send',
            icon: <SendOutlinedIcon color='warning' />,
            action: () => {
                setForm({
                    // channel_access_token: row.channel_access_token || '',
                    group_line_id: row.group_line_id || '',
                })
            },
        },
        // {
        //     title: 'Delete',
        //     icon: <DeleteOutlineOutlinedIcon color='error' />,
        //     action: () => console.log('Delete'),
        // },
    ].filter(Boolean)

    const columns = [
        {
            id: 'id',
            label: 'No.',
            width: '5%',
            align: 'center',
        },
        {
            id: 'name',
            label: 'Name',
            width: '20%',
            align: 'left',
        },
        { id: 'keyName', label: 'Keyname', width: '40%', align: 'left' },
        {
            id: 'last_update',
            label: 'Last update',
            width: '20%',
            align: 'left',
        },
        {
            id: 'enable_line_oa',
            label: 'Enabled',
            width: '20%',
            align: 'left',
            type: 'switch',
        },

        {
            id: 'actions',
            label: '',
            width: '5%',
            align: 'center',
        },
    ]
    const handleAlert = (message, status) => {
        handdleOpenAlert(setOpenAlert, setMessage, message, status)
    }

    const getData = useCallback(async () => {
        try {
            setError(false)
            const res = await axiosInstance.get(urlConfig.lineOA)

            if (res.data.channel_access_token) {
                setAccessToken({
                    channel_access_token: atob(res.data.channel_access_token),
                })
            }
            if (res.data.message && res.data.message.length > 0) {
                setData(
                    res.data.message.map((item, index) => ({
                        ...item,
                        id: index + 1,
                        last_update: formatDate(item.updatedAt),
                    })),
                )
            }
        } catch (error) {
            setError(true)
            handleAlert(
                error.response?.data?.message || 'Failed to fetch line OA',
                'error',
            )
        }
    }, [])

    useEffect(() => {
        getData()
    }, [getData])

    const handleSwitchChange = async (row) => {
        try {
            const res = await axiosInstance.put(
                `${urlConfig.lineOA}/keyName/${row.keyName}`,
                { enable_line_oa: !row.enable_line_oa },
            )
            if (res.data.message) {
                handleAlert('Line OA updated successfully', 'success')
            }
            getData()
        } catch (error) {
            handleAlert(
                error.response?.data?.message || 'Failed to update line OA',
                'error',
            )
        }
    }

    const testSend = async (e) => {
        setLoading(true)
        e.preventDefault()
        try {
            const res = await axiosInstance.post(
                `${urlConfig.lineOA}/test-send`,
                form,
            )
            if (res.data.message) {
                handleAlert('Line OA sent successfully', 'success')
            }
        } catch (error) {
            handleAlert(
                error.response?.data?.message || 'Failed to send line OA',
                'error',
            )
        } finally {
            setLoading(false)
        }
    }

    const handleView = (row) => {
        setShowToken(!showToken)
    }

    const handleCopy = () => {
        navigator.clipboard
            .writeText(accessToken.channel_access_token)
            .then(() => {
                handleAlert('Copied to clipboard!', 'success')
            })
            .catch(() => {
                handleAlert('Failed to copy', 'error')
            })
    }

    const handleSave = async (row) => {
        try {
            setLoading(true)
            const response = await axiosInstance.put(
                `${urlConfig.lineOA_accessToken}`,
                accessToken,
            )
            if (response.status === 200) {
                handleAlert('Saved successfully', 'success')
                setData((prev) =>
                    prev.map((item) =>
                        item.id === row.id ? response.data : item,
                    ),
                )
            }
        } catch (error) {
            handleAlert(error.message || 'Failed to save', 'error')
        } finally {
            setLoading(false)
        }
    }

    return (
        <div style={{ marginBottom: '20px' }}>
            <form onSubmit={testSend}>
                <Grid container spacing={2} p={3}>
                    <Grid item xs={12} md={11}>
                        <TextField
                            required
                            sx={{ width: '95%' }}
                            label='Channel Access Token'
                            name='channel_access_token'
                            size='small'
                            type={showToken ? 'text' : 'password'}
                            value={accessToken.channel_access_token}
                            onChange={(e) =>
                                setAccessToken({
                                    ...accessToken,
                                    channel_access_token: e.target.value,
                                })
                            }
                        />
                    </Grid>
                    <Grid item xs={12} md={1}>
                        <Box
                            sx={{
                                display: 'flex',
                                justifyContent: 'center',
                            }}
                        >
                            <IconButton
                                size='small'
                                onClick={() => handleView(row)}
                            >
                                {!showToken ? (
                                    <VisibilityOffOutlinedIcon />
                                ) : (
                                    <RemoveRedEyeOutlinedIcon />
                                )}
                            </IconButton>
                            <Tooltip title={`Copy`}>
                                <IconButton size='small' onClick={handleCopy}>
                                    <ContentCopyOutlinedIcon />
                                </IconButton>
                            </Tooltip>
                            <Tooltip title={`Save`}>
                                <span>
                                    <IconButton
                                        disabled={!update}
                                        size='small'
                                        onClick={() => handleSave(row)}
                                    >
                                        <SaveOutlinedIcon />
                                    </IconButton>
                                </span>
                            </Tooltip>
                        </Box>
                    </Grid>

                    <Grid item xs={12} md={11}>
                        <TextField
                            required
                            sx={{ width: '95%' }}
                            label='Group/User ID to send test'
                            name='channel'
                            size='small'
                            value={form.group_line_id}
                            onChange={(e) =>
                                setForm({
                                    ...form,
                                    group_line_id: e.target.value,
                                })
                            }
                        />
                    </Grid>

                    <Grid item xs={12} md={1}>
                        <Button
                            fullWidth
                            variant='contained'
                            color='success'
                            type='submit'
                            disabled={loading}
                        >
                            SEND
                        </Button>
                    </Grid>
                </Grid>
            </form>
            <LineForm
                open={open}
                setOpen={setOpen}
                row={row}
                handleAlert={handleAlert}
                refresh={getData}
            />
            <TableComponents
                error={error}
                handleSwitchChange={handleSwitchChange}
                columns={columns}
                data={data}
                MenuList={listMenu}
                setAction={setRow}
            />
            <AlertPopup
                message={message}
                open={openAlert}
                setOpen={setOpenAlert}
            />
        </div>
    )
}
const formatDate = (isoString) => {
    const date = new Date(isoString)
    const day = String(date.getDate()).padStart(2, '0')
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const year = date.getFullYear()
    const hours = String(date.getHours()).padStart(2, '0')
    const minutes = String(date.getMinutes()).padStart(2, '0')
    const seconds = String(date.getSeconds()).padStart(2, '0')
    return `${day}/${month}/${year}, ${hours}:${minutes}:${seconds}`
}
